/**
 * PasswordReset container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Login from '../../Components/Login/Login';

import LoginActions from './actions';
import {
  loadingSelector,
  errorSelector,
  required2FASelector,
  loginPossible2faMethods,
} from './selectors';
import { loggedInSelector, ssoLoggedInSelector } from '../App/selectors';

const { login, loginInvalid2FA } = LoginActions;

function Component(props) {
  return <Login {...props} />;
}

/**
 * Properties to be provided to the PasswordReset component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  isLoggedIn: loggedInSelector(state),
  is2FARequired: required2FASelector(state),
  possible2faMethods: loginPossible2faMethods(state),
  isSSOLoggedIn: ssoLoggedInSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch login actions
 */
const mapDispatchToProps = (dispatch) => ({
  login: (email, password, token2FA, method2FA) =>
    dispatch(login(email, password, token2FA, method2FA)),
  loginInvalid2FA: (error) => dispatch(loginInvalid2FA(error)),
});

/**
 * Connects login state to the PasswordReset component
 *
 * @param {object} mapStateToProps data object to become props for the PasswordReset component
 * @param {object} mapDispatchToProps login actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Component),
);
